"use strict";

// import page related style
require("client/pages/bictoleisearch/style/index.css");
// import shared js functions
require("client/index.js");
require("client/swiftref_box.js");

/**
 * data_access registers the DOWNLOAD_FILE listener at require time, so it must
 * be loaded BEFORE presentation.js dispatches the emailed-token download.
 */
require("client/pages/bictoleisearch/data_access")();
const presentation = require("client/pages/bictoleisearch/presentation");

presentation.bindEventListeners();
